import { z } from 'zod';

import { METADATA_KEY_VALIDATION } from '../constants';

const getMetadataKeyFormatError = (
  value: string,
  pattern: RegExp
): string | undefined => {
  if (/\d/.test(value)) {
    return METADATA_KEY_VALIDATION.NUMBER_ERROR;
  }

  if (/[A-Z]/.test(value)) {
    return METADATA_KEY_VALIDATION.UPPERCASE_ERROR;
  }

  if (/[^a-z_]/.test(value)) {
    return METADATA_KEY_VALIDATION.SPECIAL_CHAR_ERROR;
  }

  if (!pattern.test(value)) {
    return METADATA_KEY_VALIDATION.FORMAT_ERROR;
  }

  return undefined;
};

export const metadataKeySchema = z
  .string()
  .min(1, METADATA_KEY_VALIDATION.EMPTY_ERROR)
  .superRefine((value, ctx) => {
    if (!value.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: METADATA_KEY_VALIDATION.EMPTY_ERROR,
      });
      return;
    }

    if (/\s/.test(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: METADATA_KEY_VALIDATION.SPECIAL_CHAR_ERROR,
      });
      return;
    }

    const formatError = getMetadataKeyFormatError(
      value.trim(),
      METADATA_KEY_VALIDATION.PATTERN
    );

    if (formatError) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: formatError,
      });
    }
  });

export const validateMetadataKey = (value: string): string | undefined => {
  if (!value.trim()) {
    return value.length > 0
      ? METADATA_KEY_VALIDATION.SPECIAL_CHAR_ERROR
      : METADATA_KEY_VALIDATION.EMPTY_ERROR;
  }

  if (/\s/.test(value)) {
    return METADATA_KEY_VALIDATION.SPECIAL_CHAR_ERROR;
  }

  return getMetadataKeyFormatError(
    value.trim(),
    METADATA_KEY_VALIDATION.IN_PROGRESS_PATTERN
  );
};

export const isValidMetadataKey = (key: string): boolean => {
  if (validateMetadataKey(key)) {
    return false;
  }

  const trimmed = key.trim();
  return METADATA_KEY_VALIDATION.PATTERN.test(trimmed);
};
